import { z } from 'zod'

export const sendJoinMessageSchema = z.object({
  content: z.string().min(1, 'Message is required').max(2000, 'Message must be 2000 characters or less'),
})

export const joinChatQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(100).default(50),
})

export type SendJoinMessageInput = z.infer<typeof sendJoinMessageSchema>
export type JoinChatQueryInput = z.infer<typeof joinChatQuerySchema>
